import React from "react";
import { Formik, Field, Form } from "formik";
import { TextField, Loading, GalleryField } from "components/form";
import { required, validationWrapper, number } from "lib/formValidations";
import {
  transformTranslateFromValues,
  transformTranslateServerValues,
} from "lib/helpers";
import Modal from "components/Modal";
import { TextArea, Select } from "components/form";
import { useCore } from "store/core";
import cleanObject from "utils/editHelper";
import { CkEditor } from "components/form";
import TextFieldSlug from "components/form/TextFieldSlug";
// components

const types = [
  { label: "خبر", value: "News" },
  // { label: "ویدیو", value: "Video" },
];

export default function Edit(props) {
  const core = useCore();
  const { show, item } = props;

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{ ...transformTranslateServerValues(item) }}
          onSubmit={async (values, { setSubmitting }) => {
            if (!values.parent_id) {
              delete values.parent_id;
            }

            const clean = cleanObject(values, [
              "id",
              "updatedAt",
              "uuid",
              "createdAt",
            ]);

            await props.submit(clean, item.id);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty }) => (
            <Form>
              <div className="modal-body py-1 gap-y-3">
                <div className="intro-y  col-span-12 sm:col-span-12 grid grid-cols-2 gap-x-2">
                  <Field
                    placeholder="نام"
                    label="نام :"
                    name="translations.fa.title"
                    component={TextFieldSlug}
                    slugFieldName="translations.fa.slug"
                  />
                  <Field
                    placeholder="name"
                    label="نام انگلیسی :"
                    name="translations.en.title"
                    component={TextFieldSlug}
                    slugFieldName="translations.en.slug"
                  />
                </div>

                <div className="intro-y">
                  <Field
                    label="نوع :"
                    name="type"
                    component={Select}
                    options={types}
                    className="w-full px-3 py-2 border rounded"
                  />
                </div>

                <div className="intro-y  col-span-12 sm:col-span-12 grid grid-cols-2 gap-x-2">
                  <div className="intro-y">
                    <Field
                      label="نامک:"
                      name="translations.fa.slug"
                      component={TextField}
                    />
                  </div>
                  <div className="intro-y">
                    <Field
                      label="نامک انگلیسی:"
                      name="translations.en.slug"
                      component={TextField}
                    />
                  </div>
                </div>

                {/* <div>
                           {core.slidersLoad ? (
                             <Loading />
                           ) : (
                             <Field
                               label="اسلایدر :"
                               name="slider_id"
                               valueOnly
                               component={Select}
                               options={core.sliders || []}
                             />
                           )}
                         </div> */}
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
